/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ThemeMode = {
    UserChoice: 'UserChoice',
    LightOnly: 'LightOnly',
    DarkOnly: 'DarkOnly'
} as const;
export type ThemeMode = typeof ThemeMode[keyof typeof ThemeMode];


export function instanceOfThemeMode(value: any): boolean {
    for (const key in ThemeMode) {
        if (Object.prototype.hasOwnProperty.call(ThemeMode, key)) {
            if (ThemeMode[key as keyof typeof ThemeMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ThemeModeFromJSON(json: any): ThemeMode {
    return ThemeModeFromJSONTyped(json, false);
}

export function ThemeModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThemeMode {
    return json as ThemeMode;
}

export function ThemeModeToJSON(value?: ThemeMode | null): any {
    return value as any;
}

export function ThemeModeToJSONTyped(value: any, ignoreDiscriminator: boolean): ThemeMode {
    return value as ThemeMode;
}

